import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { HeadingComponent } from 'src/app/shared/components/heading/heading.component';
import {
  LEARN_MORE_EXTERNAL_LINK,
  LoyaltyBadgeNameEnum,
} from 'src/app/shared/components/loyalty-badge/constants/loyalty-badges';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-loyalty-badge-modal',
  standalone: true,
  templateUrl: './loyalty-badge-modal.component.html',
  styleUrls: ['./loyalty-badge-modal.component.scss'],
  imports: [ButtonComponent, HeadingComponent, IonicModule, NgIf],
})
export class LoyaltyBadgeModalComponent {
  @Input() badgeName: string;

  @Output() onDismiss = new EventEmitter<void>();

  readonly LoyaltyBadgeNames = LoyaltyBadgeNameEnum;

  constructor(private readonly utilityService: UtilityService) {}

  learnMore(): void {
    this.utilityService.openExternalLink(LEARN_MORE_EXTERNAL_LINK);
  }

  dismiss(): void {
    this.onDismiss.emit();
  }
}
